import { Component, ViewEncapsulation, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'deleted-user',
    templateUrl: 'deleted.user.component.html',
    styleUrls: ['deleted.user.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class DeletedUserComponent {

    @HostBinding('class.modern-form') modern = true;
}